import React, { type SVGProps } from 'react';
import type { IconType } from './IconType';
import * as Icons from './icons';


export enum IconSize {
  SMALL = 16,
  MEDIUM = 18,
  LARGE = 20,
}

export type IconProps = SVGProps<SVGSVGElement> & {
  icon: IconType;
  size?: IconSize;
  color?: string;
};

const customIconStyle = `
  .custom-icon path, .custom-icon rect {
    stroke: currentColor;
  }
`;

const wrapperStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  alignSelf: 'center',
  lineHeight: 0,
  flexShrink: 0,
};

export const Icon: React.FC<IconProps> = ({ icon, size = IconSize.MEDIUM, color, ...props }) => {
  const IconSvg = Icons[icon];

  return (
    <span className="custom-icon" style={wrapperStyle}>
      <style>{customIconStyle}</style>
      <IconSvg
        {...props}
        width={size.toString() + 'px'}
        height={size.toString() + 'px'}
        color={color}
      />
    </span>
  );
};